import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1774888044/src/pubgen-app/next-app/app/(authenticated)/client.tsx");
